export default "__VITE_ASSET__9dc21b2f__"